<script>
	import { onMount } from "svelte";
	import { menu, menuSub, menuSubSub } from "../stores";
	// 수면 탭용 컴포넌트
	import MusicSleeps from "./contents/MusicSleeps.svelte";

	// 탭 상태: 'user' (사용자) / 'sleep' (수면) — 기본값은 'user'
	let activeTab = "user";

	let dashboardUrl = "";
	let serverTitle = "";
	let iframeHeight = "calc(100vh - 200px)"; // 기본값

	$: {
		const server = localStorage.getItem("selectedServer");
		let grafanaKeyUser = "";
		let grafanaKeySleep = "";
		switch (server) {
			case "us-api-backstage.sleepwave.ai":
				serverTitle = "US Server";
				grafanaKeyUser = "102dbf7f2d584b2d8e6668b9bd77534d";
				grafanaKeySleep = "b6f01f12331145ba8bb747afc65c3748";
				break;
			case "kr-api-backstage.sleepwave.ai":
				serverTitle = "KR Server";
				grafanaKeyUser = "7668dc4255c444ae93a18990da913c25";
				grafanaKeySleep = "b9d76b07ede341978927baa0619d5f2a";
				break;
			case "dev-api-backstage.blaupunkt-solum.cn":
				serverTitle = "China DEV Server";
				grafanaKeyUser = "ab3a3dae56be4293bc136e9499d68a5c";
				grafanaKeySleep = "19ce41ed7ff1449086d54799b749e396";
				break;
			case "api-backstage.blaupunkt-solum.cn":
				serverTitle = "China PRD Server";
				grafanaKeyUser = "ab3a3dae56be4293bc136e9499d68a5c";
				grafanaKeySleep = "19ce41ed7ff1449086d54799b749e396";
				break;
			default:
				grafanaKeyUser = "7668dc4255c444ae93a18990da913c25";
				grafanaKeySleep = "b9d76b07ede341978927baa0619d5f2a";
				serverTitle = "Development Server";
				break;
		}
		switch (activeTab) {
			case "user":
				dashboardUrl = `https://monitor.sleepwave.ai/public-dashboards/${grafanaKeyUser}`;
				break;
			case "sleep":
				dashboardUrl = `https://monitor.sleepwave.ai/public-dashboards/${grafanaKeySleep}`;
				break;
			case "hardware":
				dashboardUrl = "https://monitor.sleepwave.ai/d/rYdddlPWk/node-exporter-full?orgId=1&kiosk"
		}
	}

	onMount(() => {
		menu.set("Home");
		menuSub.set("Dashboard");
		menuSubSub.set("");

		// 고정 높이 계산 (예: 창 높이에서 헤더와 푸터 높이를 뺀 값)
		const windowHeight = window.innerHeight;
		const headerHeight = 100; // 헤더 높이 예상값
		const footerHeight = 100; // 푸터 높이 예상값
		const fixedHeight = windowHeight - headerHeight - footerHeight;

		iframeHeight = `${fixedHeight}px`;
	});
</script>

<!-- 탭 네비게이션 -->
<ul class="nav nav-tabs mb-3">
	<li class="nav-item">
		<button type="button" class="nav-link {activeTab === 'user' ? 'active' : ''}" on:click={() => (activeTab = "user")}>사용자</button>
	</li>
	<li class="nav-item">
		<button type="button" class="nav-link {activeTab === 'sleep' ? 'active' : ''}" on:click={() => (activeTab = "sleep")}>수면</button>
	</li>
	<li class="nav-item">
		<button type="button" class="nav-link {activeTab === 'hardware' ? 'active' : ''}" on:click={() => (activeTab = "hardware")}>하드웨어</button>
	</li>
</ul>

<div class="card mb-1 bg-white" style="overflow: hidden; height: {iframeHeight};">
	<iframe src={dashboardUrl} title="Sleepwave Dashboard" width="100%" height="100%" style="border: none; display: block;"></iframe>
</div>
